import React, { Ref } from 'react';
import { Input, InputRef } from 'antd';

interface EPInputProps {
  [x: string]: unknown;
}

const EPInput = React.forwardRef((props: EPInputProps, ref: Ref<InputRef>) => {
  return <Input size="large" {...props} ref={ref} />;
});

export default EPInput;
